import { CoreIcon } from '../core-icon';
import mochipayCircleColorSVG from '../../assets/icons/mochipay-circle-color.svg';
import type { IconProps } from '../core-icon';

export const MochipayCircleColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={mochipayCircleColorSVG} {...props} />;
};
